import PropTypes from 'prop-types'
import React from 'react'
import { get } from 'lodash'

import MetaCategories from '../../pages/search/result/metaCategories'
import AudioPlayerLargeContainer from '../audio/audioPlayerLargeContainer'
import ItemActions from './common/itemActions'
import TrendingSash from './common/trendingSash'
import pad from '../../../common/utils/pad'
import { getItemAttribute } from '../../../common/utils/item'
import BarChartIcon from '../icons/barChart'
import ClockIcon from '../icons/clock'
import TempoIcon from '../icons/tempo'

import styles from './listAudio.module.css'

const ItemCardListAudio = ({
  item,
  onAddToFavourites,
  rank,
  onAddToCollections,
  onItemLinkClick,
  onAddToCart
}) => {
  const trackTempo = getItemAttribute(item, 'bpm')
  const length = get(item, 'previews.icon_with_audio_preview.length')
  const trackLengthHours = length && length.hours ? `${length.hours}:` : ''
  const trackLength = length
    ? `${trackLengthHours}${pad(length.minutes, 2)}:${pad(length.seconds, 2)}`
    : null

  return (
    <div className={styles.container}>
      <div className={styles.itemSummary}>
        <a
          className={styles.thumbnail}
          href={`${item.url}?s_rank=${rank}`}
          onClick={onItemLinkClick}
        >
          <img
            alt={item.name}
            width="80"
            height="80"
            src={item.ui.smallPreviewUrl}
            title={item.name}
          />
        </a>
        <ItemActions
          item={item}
          onAddToFavourites={onAddToFavourites}
          onAddToCollections={onAddToCollections}
          onAddToCart={onAddToCart}
        />
      </div>
      <div className={styles.itemDescription}>
        <div className={styles.flexColumn}>
          <div className={styles.spaceBetween}>
            <h3 className="fds-u-m0 fds-c-text-heading -size-xs">
              <a
                className="fds-c-text-link -color-inherit -decoration-reversed"
                href={`${item.url}?s_rank=${rank}`}
                onClick={onItemLinkClick}
              >
                {item.name}
              </a>
            </h3>
            <span>
              by{' '}
              <a
                className="fds-c-text-link -color-dark -decoration-reversed"
                href={item.author_url}
              >
                {item.author_username}
              </a>
            </span>
          </div>

          <AudioPlayerLargeContainer item={item} />

          <div className={styles.meta}>
            <p className="fds-c-text-body -size-xs fds-u-m0">
              <MetaCategories
                classification={item.classification}
                className="meta-categories -no-slash"
              />
            </p>
            <div>
              {trackLength ? (
                <span className="fds-u-pr2">
                  <ClockIcon />
                  <span
                    className="fds-c-text-body -size-xs -weight-bold fds-u-m0  fds-u-pl1"
                    data-test-selector="duration"
                  >
                    {trackLength}
                  </span>
                </span>
              ) : null}
              {trackTempo ? (
                <span className="fds-u-pr2">
                  <TempoIcon />
                  <span className="fds-c-text-body -size-xs -weight-bold fds-u-m0 fds-u-pl1">
                    {trackTempo}
                  </span>
                </span>
              ) : null}
              {item.number_of_sales ? (
                <span className="fds-u-pr4">
                  <BarChartIcon />
                  <span className="fds-c-text-body -size-xs -weight-bold fds-u-m0 fds-u-pl1">
                    {item.number_of_sales}
                  </span>
                </span>
              ) : null}
              <span className="fds-c-text-heading -size-xs">
                <b className="fds-c-text-currency">${item.ui.price}</b>
              </span>
            </div>
          </div>
        </div>
      </div>
      {item.trending && <TrendingSash />}
    </div>
  )
}

ItemCardListAudio.propTypes = {
  item: PropTypes.object.isRequired,
  onAddToFavourites: PropTypes.func.isRequired,
  rank: PropTypes.number.isRequired,
  onItemLinkClick: PropTypes.func,
  onAddToCart: PropTypes.func
}

export default ItemCardListAudio



// WEBPACK FOOTER //
// ./client/components/itemCard/listAudio.js